/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillEnumItem
 */
export interface BillEnumItem {
    /**
     * 编码
     * @type {number}
     * @memberof BillEnumItem
     */
    code?: number;
    /**
     * 枚举标识名
     * @type {string}
     * @memberof BillEnumItem
     */
    enumName?: string;
    /**
     * 名称（根据语言环境返回）
     * @type {string}
     * @memberof BillEnumItem
     */
    name?: string;
}

/**
 * Check if a given object implements the BillEnumItem interface.
 */
export function instanceOfBillEnumItem(value: object): value is BillEnumItem {
    return true;
}

export function BillEnumItemFromJSON(json: any): BillEnumItem {
    return BillEnumItemFromJSONTyped(json, false);
}

export function BillEnumItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillEnumItem {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'enumName': json['enumName'] == null ? undefined : json['enumName'],
        'name': json['name'] == null ? undefined : json['name'],
    };
}

export function BillEnumItemToJSON(json: any): BillEnumItem {
    return BillEnumItemToJSONTyped(json, false);
}

export function BillEnumItemToJSONTyped(value?: BillEnumItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'enumName': value['enumName'],
        'name': value['name'],
    };
}

